import { GzCompanyRiskScoreWebComponent } from './component/CompanyRiskScoreWebComponent';

export { GzCompanyRiskScoreWebComponent };
